import * as v from 'valibot';

import type { MaoLocation } from '../types';

export const maoLocationSchema: v.GenericSchema<MaoLocation> = v.object({
  AircraftId: v.number('Aircraft ID is missing'),
  Latitude: v.number('Latitude is missing'),
  Longitude: v.number('Longitude is missing'),
  Heading: v.number('Heading is missing'),
  LocationTimestamp: v.string('Location timestamp is missing'),
});
